import CancelIcon from '@mui/icons-material/Cancel';
import { Chip, type ChipProps } from '@mui/material';
import React from 'react';

export const AccessibleChip = ({ onDelete, label, ...props }: ChipProps) => {
  return (
    <Chip
      label={label}
      onDelete={onDelete}
      variant="secondary"
      deleteIcon={
        onDelete ? (
          <CancelIcon
            tabIndex={0}
            role="button"
            aria-label={`Remove ${label}`}
            onKeyDown={(e: React.KeyboardEvent<SVGSVGElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onDelete(e);
              }
            }}
            sx={{
              backgroundColor: 'var(--color-scifree-dark-gray)',
              borderRadius: '50%',
              '&:focus-visible': {
                outline: '2px solid var(--color-scifree-teal)',
                outlineOffset: '2px',
              },
            }}
          />
        ) : undefined
      }
      {...props}
    />
  );
};
